/* eslint-disable no-redeclare */
class ErrorLogServiceError extends Error {
  /** Error type */
  type: ErrorLogServiceError.Type;

  constructor(type: ErrorLogServiceError.Type = ErrorLogServiceError.Type.general, ...params: any[]) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ErrorLogServiceError);
    }

    this.name = "ErrorLogServiceError";
    // Custom debugging information
    this.type = type;
  }
}

namespace ErrorLogServiceError {
  export enum Type {
    general = "General error",
    noAuthenticatedCognitoUser = "No authenticated cognito user",
    noAccessId = "No accessId",
    responseError = "Response error",
    networkError = "Network error",
  }
}

export default ErrorLogServiceError;
